import { VERIFICATION } from "@/constants/treeConstants";
import { TRANSLATION_OR_SIMULATION } from "../../CCC/cccHelper";

function getCCCVerifications(verificationList, type, projectList) {
  return [{
    type: VERIFICATION,
    name: type,
    verificationType: type,
    verificationList: [...verificationList]
  }, {
    type: TRANSLATION_OR_SIMULATION,
    name: "Translation / Simulation",
    projectList
  }]
}

function getCCCSpecifyServiceVerification(verificationId, verificationList, type) {
  if (!verificationId) {
    return null;
  }

  let verification = null, specifyServiceType = VERIFICATION;
  verification = verificationList.find(item => item.id === verificationId);

  return verification ? { ...verification, specifyServiceType } : null;
}

export {
  getCCCVerifications,
  getCCCSpecifyServiceVerification
}